import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {StateService} from '../../../shared/services/state.service';
import {StockistService} from '../../../shared/services/stockist.service';
import {FileService} from '../../../shared/services/file.service';
import {SupportService} from '../../../shared/services/support.service';

@Component({
    selector: 'app-add-support-ticket',
    templateUrl: './add-support-ticket.component.html',
    styleUrls: ['./add-support-ticket.component.scss']
})
export class AddSupportTicketComponent implements OnInit {

    addSupportForm: FormGroup;
    id: any;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    states: any = [];
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;
    onFileChangedSupport: any;
    docSubmittingSupport: any = false;
    supportDocData: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private stockistServices: StockistService,
                private alertService: AlertService,
                private stateService: StateService,
                private fileService: FileService,
                private supportService: SupportService) {
    }

    ngOnInit(): void {
        this.getStates();
    }

    ngOnChanges(): void {
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-ticket').toggleOpen();
    }

    refresh() {
        this.addSupportForm = this.fb.group({
            'type': ['', Validators.required],
            'subject': ['', (!this.id) ? Validators.required : ''],
            'remark': ['', Validators.required]
        });
        if (this.data) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addSupportForm.patchValue({
            'type': (this.data && this.data['type']) ? this.data['type'] : '',
            'subject': (this.data && this.data['subject']) ? this.data['subject'] : '',
            'remarks': (this.data && this.data['remarks']) ? this.data['remarks'] : ''
        });
    }

    getStates() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
            }
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addSupportForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'type': (this.addSupportForm.value && this.addSupportForm.value.type) ? this.addSupportForm.value.type : '',
                'subject': (this.addSupportForm.value && this.addSupportForm.value.subject) ? this.addSupportForm.value.subject : '',
                'remark': (this.addSupportForm.value && this.addSupportForm.value.remark) ? this.addSupportForm.value.remark : '',
                'support_document': (this.supportDocData && this.supportDocData.id) ? this.supportDocData.id : '',
            };
            this.submitting = true;
            this.supportService.create(params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addSupportForm.reset();
                    this.addSupportForm.patchValue({
                        'remark': '',
                        'subject': '',
                        'type': ''
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].subject && error['error']['errors'].subject.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].subject[0]);
                        return;
                    }
                    if (error['error']['errors'].remark && error['error']['errors'].remark.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].remark[0]);
                        return;
                    }
                    if (error['error']['errors'].type && error['error']['errors'].type.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].type[0]);
                        return;
                    }
                }
            });
        }
    }


    update() {
        this.submitted = true;
        if (!this.addSupportForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addSupportForm.value && this.addSupportForm.value.name) ? this.addSupportForm.value.name : '',
                'username': (this.addSupportForm.value && this.addSupportForm.value.username) ? this.addSupportForm.value.username : '',
                'email': (this.addSupportForm.value && this.addSupportForm.value.email) ? this.addSupportForm.value.email : '',
                'contact': (this.addSupportForm.value && this.addSupportForm.value.contact) ? this.addSupportForm.value.contact : '',
                'password': (this.addSupportForm.value && this.addSupportForm.value.password) ? this.addSupportForm.value.password : '',
                'address': (this.addSupportForm.value && this.addSupportForm.value.address) ? this.addSupportForm.value.address : '',
                'state_id': (this.addSupportForm.value && this.addSupportForm.value.state_id) ? this.addSupportForm.value.state_id : '',
                'city': (this.addSupportForm.value && this.addSupportForm.value.city) ? this.addSupportForm.value.city : '',
                'pin_code': (this.addSupportForm.value && this.addSupportForm.value.pin_code) ? this.addSupportForm.value.pin_code : '',
            };
            this.submitting = true;
            this.stockistServices.update(this.data.unique_id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].username[0]);
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }

    onFileChange(e, type) {
        this.onFileChangedSupport = e;
        this.docSubmittingSupport = true;
        this.fileService.fileUpload({
            'type': 'SUPPORT_DOCUMENT',
            'fileType': 'NORMAL'
        }, this.onFileChangedSupport).subscribe(data => {
            this.supportDocData = data['data'];
            this.docSubmittingSupport = false;
            this.alertService.showSuccess({title: 'Success', message: 'Uploaded Successfully'});
        }, error => {
            this.docSubmittingSupport = false;
            this.alertService.showErrors('Something went wrong, please try again');
        });
    }

    openExternalUrl(url) {
        window.open(url, '_blank');
    }
}
